

export const agencyCore = {
  header: {
    home: { vi: "Trang chủ Đối tác", bn: "পার্টনার হোমপেজ" },
    roadmap: { vi: "Quy trình phát triển thị trường", bn: "সহযোগিতার পথচিত্র" },
    jobs: { vi: "Quản lý việc làm", bn: "চাকরি quản lý" },
    candidates: { vi: "Quản lý ứng viên", bn: "প্রার্থী ব্যবস্থাপনা" },
    shareDocuments: { vi: "Tài liệu chia sẻ", bn: "শেয়ার করা নথি" },
    trash: { vi: "Thùng rác", bn: "আবর্জনা বাক্স" },
    login: { vi: "Đăng nhập", bn: "লগইন করুন" },
    logout: { vi: "Thoát", bn: "প্রস্থান" },
    logoutDesc: { vi: "Kết thúc phiên làm việc", bn: "সেশন শেষ করুন" },
    notifications: { vi: "Thông báo", bn: "বিজ্ঞপ্তি" },
    noNotifications: { vi: "Không có thông báo mới", bn: "কোন mới thông báo নেই" },
    markAllRead: { vi: "Đánh dấu đã đọc tất cả", bn: "সব পড়া হয়েছে হিসেবে চিহ্নিত করুন" },
    deleteAll: { vi: "Xóa tất cả", bn: "সব মুছে ফেলুন" },
    partnerSystemFooter: { vi: "Hệ thống Đối tác HelloJob Bangladesh", bn: "হ্যালোজব বাংলাদেশ পার্টনার সিস্টেম" },
    rejectionReasons: {
      title: { vi: "Chọn lý do từ chối", bn: "প্রত্যাখ্যানের कारण নির্বাচন করুন" },
      incomplete: { vi: "Hồ sơ chưa đầy đủ thông tin", bn: "প্রোফাইল তথ্য অসম্পূর্ণ" },
      unsuitable: { vi: "Không phù hợp với tiêu chí tuyển dụng", bn: "নিয়োগের মানদণ্ডের জন্য উপযুক্ত নয়" },
      wrongAgency: { vi: "Thông tin công ty phái cử không chính xác", bn: "ভুল প্রেরণকারী সংস্থার তথ্য" },
      other: { vi: "Lý do khác", bn: "অন্যান্য কারণ" }
    },
    avatarMenu: {
      myAccount: { vi: "TÀI KHOẢN ĐỐI TÁC", bn: "পার্টনার অ্যাকাউন্ট" },
      viewPublic: { vi: "Xem hồ sơ công khai", bn: "পাবলিক প্রোফাইল দেখুন" },
      viewPublicDesc: { vi: "Hồ sơ dành cho khách hàng", bn: "গ্রাহকদের জন্য প্রোফাইল" },
      viewInternal: { vi: "Xem hồ sơ nội bộ", bn: "অভ্যন্তরীণ প্রোফাইল দেখুন" },
      viewInternalDesc: { vi: "Thông tin trong hệ thống", bn: "সিস্টেম তথ্য" },
      editProfile: { vi: "Sửa hồ sơ của tôi", bn: "আমার প্রোফাইল সম্পাদনা করুন" },
      editProfileDesc: { vi: "Cập nhật thông tin", bn: "তথ্য আপডেট করুন" },
      shareProfile: { vi: "Chia sẻ hồ sơ", bn: "প্রোফাইল শেয়ার করুন" },
      shareProfileDesc: { vi: "Gửi cho đối tác khác", bn: "অন্যান্য অংশীদারদের পাঠান" },
      shareDialogTitle: { vi: "Sao chép Link hồ sơ", bn: "প্রোফাইল লিঙ্ক কপি করুন" },
      publicLink: { vi: "Link công khai", bn: "পাবলিক লিঙ্ক" },
      internalLink: { vi: "Link đối tác", bn: "পার্টনার লিঙ্ক" },
      copy: { vi: "Sao chép", bn: "কপি করুন" },
      copied: { vi: "Đã sao chép!", bn: "কপি করা হয়েছে!" }
    }
  },
  hero: {
    title: { vi: "Hệ thống Đối tác Chiến lược & Phát triển Thị trường Bangladesh", bn: "বাংলাদেশ জনশক্তি সরবরাহ অংশীদার সিস্টেম" },
    subtitle: { vi: "Xây dựng hệ thống khách hàng doanh nghiệp, nhà máy tại Việt Nam. Tuyển chọn lao động chất lượng cao trong các lĩnh vực Xây dựng, Cơ khí, Điện tử, May mặc, Hàn xì.", bn: "ভিয়েতনামের শ্রম বাজারের জন্য বাংলাদেশি ট্যালেন্ট সুপারমার্কেট তৈরি করা। টেকসই এবং কার্যকরভাবে একসাথে বিকাশের জন্য একটি কৌশলগত অংশীদার হন।" },
    labels: {
      hero_title: { 
        vi: "Mô hình Đại lý cung ứng nhân lực Bangladesh tại Việt Nam", 
        bn: "হ্যালোজব - ভিয়েতনামী জনশক্তি সংস্থাগুলোর জন্য বাংলাদেশি জনশক্তি সরবরাহ সমাধান" 
      },
      hero_subtitle: { 
        vi: "Giải pháp nền tảng giúp các đại lý nhân lực phát triển bền vững trong lĩnh vực cung ứng lao động kỹ thuật, kỹ sư, chuyên gia chất lượng cao các lĩnh vực Xây dựng, May mặc, Điện tử và Cơ khí.", 
        bn: "একটি প্ল্যাটফর্ম সমাধান যা জনশক্তি সংস্থাগুলোকে নির্মাণ, পোশাক, ইলেকট্রনিক্স এবং মেকানিক্স খাতে কারিগরি শ্রম, প্রকৌশলী এবং উচ্চমানের বিশেষজ্ঞদের সরবরাহে টেকসইভাবে উন্নতি করতে সাহায্য করে।" 
      },
      laborType: { vi: "Loại hình lao động", bn: "কর্মসংস্থানের ধরন" },
      industry: { vi: "Ngành nghề", bn: "শিল্প" },
      maxSalary: { vi: "Mức lương mong muốn", bn: "কাঙ্ক্ষিত বেতন" }
    },
    placeholders: {
      allLaborTypes: { vi: "Tất cả loại hình", bn: "সব ধরনের" },
      allIndustries: { vi: "Tất cả ngành nghề", bn: "সব শিল্প" },
      allSalaries: { vi: "Tất cả mức lương", bn: "সব বেতনের স্তর" }
    },
    laborTypes: {
      general: { vi: "Lao động phổ thông", bn: "সাধারণ কর্মী" },
      skilled: { vi: "Lao động kỹ thuật", bn: "দক্ষ কর্মী" },
      engineer: { vi: "Kỹ sư, chuyên gia", bn: "ইঞ্জিনিয়ার ও শিক্ষিত কর্মী" }
    },
    salaryRange: { vi: "Từ {val}$ trở xuống", bn: "{val}$ বা তার কম থেকে" },
    search: { vi: "Tìm kiếm", bn: "অনুসন্ধান করুন" }
  },
  imageActions: {
    view: { vi: "Xem ảnh", bn: "ছবি দেখুন" },
    change: { vi: "Thay ảnh mới", bn: "নতুন ছবি পরিবর্তন করুন" },
    recrop: { vi: "Cắt lại ảnh", bn: "আবার ক্রপ করুন" },
    restore: { vi: "Đổi lại ảnh cũ", bn: "পুরানো ছবি পুনরুদ্ধার করুন" },
    loading: { vi: "Đang tải", bn: "লোড হচ্ছে" },
    historyTitle: { vi: "Lịch sử ảnh", bn: "ছবির ইতিহাস" },
    cropErrorTitle: { vi: "Lỗi cắt ảnh", bn: "ছবি ক্রপিং ত্রুটি" },
    cropErrorDesc: { vi: "Đã có lỗi xảy ra trong quá trình xử lý ảnh. Vui lòng thử lại.", bn: "ছবি প্রক্রিয়াকরণের সময় একটি ত্রুটি ঘটেছে। অনুগ্রহ করে আবার চেষ্টা করুন।" },
    currentLabel: { vi: "Đang dùng", bn: "বর্তমানে ব্যবহৃত" },
    delete: { vi: "Xóa", bn: "মুছে ফেলুন" },
    close: { vi: "Đóng", bn: "বন্ধ করুন" },
    save: { vi: "Lưu", bn: "সংরक्षण করুন" },
    cancel: { vi: "Hủy", bn: "বাতিল" }
  },
  footer: {
    desc: { vi: "Hệ thống quản lý dành cho Đối tác.", bn: "এজেন্সির জন্য প্রেষণ ব্যবস্থাপনা সিস্টেম।" },
    forAgency: { vi: "Dành cho Đối tác", bn: "এজেন্সির জন্য" },
    fastEntry: { vi: "Nhập liệu nhanh", bn: "দ্রুত ডেটা এন্ট্রি" },
    newsBoard: { vi: "Bảng tin việc làm", bn: "চাকরি নিউজবোর্ড" },
    resources: { vi: "Tài nguyên", bn: "সম্পদ" },
    about: { vi: "Về HelloJob", bn: "হ্যালোজব সম্পর্কে" },
    privacy: { vi: "Chính sách bảo mật", bn: "গোপনীয়তা নীতি" },
    support: { vi: "Hỗ trợ Đối tác chiến lược", bn: "অংশীদার সহায়তা" }
  },
  searchDialog: {
    title: { vi: "Bạn đang tìm kiếm điều gì?", bn: "আপনি কী খুঁজছেন?" },
    desc: { vi: "Hãy chọn mục tiêu để hệ thống HelloJob gợi ý kết quả chính xác nhất cho bạn.", bn: "আপনার জন্য সবচেয়ে নির্ভুল ফলাফলগুলো সাজেস্ট করার জন্য অনুগ্রহ করে আপনার লক্ষ্যটি নির্বাচন করুন।" },
    findJob: { vi: "Tìm việc làm", bn: "চাকরি খুঁজুন" },
    findCandidate: { vi: "Tìm ứng viên", bn: "প্রার্থী খুঁজুন" }
  },
  debug: {
    title: { vi: "Agency Simulation", bn: "এজেন্সি সিমুলেশন" },
    statusLabel: { vi: "Status đang hiển thị", bn: "প্রদর্শিত অবস্থা" },
    reset: { vi: "Dữ liệu thật (Reset)", bn: "আসল ডেটা (রিসেট)" },
    status: {
      unregistered: { vi: "Chưa đăng ký", bn: "নিবন্ধিত নয়" },
      pending: { vi: "Chờ duyệt", bn: "অনুমোদনের অপেক্ষায়" },
      approved: { vi: "Đã duyệt", bn: "অনুমোদিত" }
    },
    logout: { vi: "Đăng xuất ngay (Log out)", bn: "এখনই লগ আউট করুন" },
    mocking: { vi: "MOCKING", bn: "অনুকরণ" },
    languageTestingTooltip: { vi: "Kiểm thử ngôn ngữ (Tiếng Việt / Bangladesh)", bn: "ভাষা পরীক্ষা (ভিয়েতনামী / বাংলাদেশি)" },
    roleLabel: { vi: "GIẢ LẬP VAI TRÒ (Test UI)", bn: "মক রোল" },
    notificationLabel: { vi: "GIẢ LẬP THÔNG BÁO", bn: "অনুকরণ বিজ্ঞপ্তি" },
    triggerAgencyReg: { vi: "[TỔNG ĐẠI LÝ] Giả lập Đại lý Đăng ký", bn: "[মাস্টার] নতুন এজেন্সি নিবন্ধন" },
    triggerCandConnect: { vi: "[ĐẠI LÝ] Giả lập Ứng viên Kết nối", bn: "[এজেন্ট] প্রার্থীর সংযোগ অনুরোধ" },
    triggerMasterFeedback: { vi: "[ĐẠI LÝ] Phản hồi từ Tổng đại lý", bn: "[এজেন্ট] মাস্টারের প্রতিক্রিয়া" },
    resetRole: { vi: "Gỡ bỏ Vai trò (Reset)", bn: "রোল রিসেট করুন" }
  },
  joinInvitation: {
    badge: { vi: "Cơ hội hợp tác chiến lược", bn: "কৌশলগত সহযোগিতার সুযোগ" },
    title: { vi: "Trở thành Đối tác Tuyển dụng của HelloJob", bn: "হ্যালোজব নিয়োগ অংশীদার হন" },
    subtitle: { vi: "Đăng ký thông tin với Tổng đại lý (Sales Manager) của HelloJob để chính thức trở thành đối tác cung ứng nhân lực cho thị trường Việt Nam.", bn: "ভিয়েতনামী বাজারের জন্য আনুষ্ঠানিকভাবে জনশক্তি সরবরাহ অংশীদার হতে হ্যালোজব-এর মাস্টার এজেন্টের সাথে আপনার তথ্য নিবন্ধন করুন।" },
    features: {
      trust: {
        title: { vi: "Uy tín & Bảo mật", bn: "মর্যাদা ও nhà mạng" },
        desc: { vi: "Hợp tác chính thức với đầy đủ pháp lý.", bn: "সম্পূর্ণ আইনি সম্মতির সাথে অফিসিয়াল সহযোগিতা।" }
      },
      market: {
        title: { vi: "Mở rộng thị trường", bn: "বাজার সম্প্রসারণ" },
        desc: { vi: "Tiếp cận hàng nghìn công việc tại Việt Nam.", bn: "ভিয়েতনামে হাজার হাজার চাকরির সুযোগ পান।" }
      }
    },
    buttons: {
      facebook: { vi: "Tiếp tục với Facebook", bn: "ফেসবুক দিয়ে চালিয়ে যান" },
      google: { vi: "Tiếp tục với Google", bn: "গুগল দিয়ে চালিয়ে যান" },
      phone: { vi: "Tiếp tục với Số điện thoại", bn: "ফোন নম্বর দিয়ে চালিয়ে যান" }
    },
    social: {
      facebook: { vi: "Facebook", bn: "ফেসবুক" },
      google: { vi: "Google", bn: "গুগল" }
    },
    terms: {
      prefix: { vi: "Bằng việc tiếp tục, bạn đồng ý với", bn: "চালিয়ে যাওয়ার মাধ্যমে, আপনি সম্মত হন" },
      service: {
        agency: { vi: "Điều khoản đối tác", bn: "অংশীদার শর্তাবলী" },
        standard: { vi: "Điều khoản dịch vụ", bn: "পরিষেবার শর্তাবলী" }
      },
      and: { vi: "và", bn: "এবং" },
      privacy: { vi: "Chính sách bảo mật", bn: "গোপনীয়তা নীতি" }
    },
    or: { vi: "hoặc", bn: "অথবা" },
    labels: {
      email: { vi: "Email", bn: "ইমেল" },
      password: { vi: "Mật khẩu", bn: "পাসওয়ার্ড" },
      forgotPassword: { vi: "Quên mật khẩu?", bn: "পাসওয়ার্ড ভুলে গেছেন?" }
    },
    login: { vi: "Đăng nhập", bn: "লগইন" },
    visual: {
      title: { vi: "Câu chuyện người lao động", bn: "শ্রমিকদের গল্প" },
      desc: { vi: "Lắng nghe chia sẻ từ những người đã thành công cùng HelloJob.", bn: "হ্যালোজব-এর সাথে সফল হওয়া ব্যক্তিদের কাছ থেকে শুনুন।" }
    },
    toast: {
      success: {
        title: { vi: "Đăng nhập Đối tác thành công!", bn: "পার্টনার লগইন সফল হয়েছে!" },
        desc: { vi: "Chào mừng Đối tác đã quay trở lại hệ thống.", bn: "পার্টনার সিস্টেমে আপনাকে স্বাগতম।" }
      },
      error: {
        title: { vi: "Lỗi đăng nhập", bn: "লগইন ত্রুটি" },
        facebook: { vi: "Không thể đăng nhập bằng Facebook. Vui lòng thử lại.", bn: "ফেসবুক দিয়ে লগইন করা যায়নি। অনুগ্রহ করে lại lại চেষ্টা করুন।" },
        google: { vi: "Không thể đăng nhập bằng Google. Vui lòng thử lại.", bn: "গুগল দিয়ে লগইন করা যায়নি। অনুগ্রহ করে lại lại চেষ্টা করুন।" },
        emailInvalid: { vi: "Email hoặc mật khẩu không chính xác.", bn: "ইমেল বা পাসওয়ার্ড ভুল।" },
        tooManyRequests: { vi: "Quá nhiều lần thử thất bại. Vui lòng thử lại sau.", bn: "অনেকগুলি ব্যর্থ প্রচেষ্টা। অনুগ্রহ করে পরে আবার চেষ্টা করুন।" },
        generic: { vi: "Đã có lỗi xảy ra. Vui lòng thử lại.", bn: "một lỗi đã xảy ra. অনুগ্রহ করে lại lại চেষ্টা করুন।" }
      }
    }
  },
  sso: {
    title: {
      standard: { vi: "Chào mừng Doanh nghiệp đến với HelloJob!", bn: "হ্যালোজবে আপনাকে স্বাগতম!" },
      agency: { vi: "Đăng nhập Đối tác", bn: "নিয়োগ অংশীদার লগইন" }
    },
    subtitle: {
      standard: { vi: "Đăng nhập để kết nối dễ dàng với nguồn nhân lực lao động tay nghề cao từ Bangladesh.", bn: "আপনার ক্যারিয়ারের সম্ভাবনা উন্মোচন করতে একটি অ্যাকাউন্ট তৈরি করুন।" },
      agency: { vi: "Vui lòng đăng nhập để bắt đầu tìm kiếm và quản lý nhân tài.", bn: "প্রতিভা অনুসন্ধান এবং পরিচালনা শুরু করতে অনুগ্রহ করে লগইন করুন।" }
    },
    visual: {
      agency: {
        title: { vi: "Mạng lưới đối tác lớn nhất Bangladesh", bn: "বাংলাদেশের বৃহত্তম জনশক্তি সরবরাহ অংশীদার নেটওয়ার্ক" },
        desc: { vi: "Cùng chúng tôi xây dựng hệ thống khách hàng doanh nghiệp bền vững tại Việt Nam.", bn: "আমাদের সাথে একটি পেশাদার এবং নিরাপদ নিয়োগ प्रक्रिया গড়ে তুলুন।" }
      },
      standard: {
        title: { vi: "Giải pháp cung ứng nhân lực toàn diện", bn: "ভিয়েতনামে আপনার স্বপ্নের চাকরি খুঁজুন" },
        desc: {
          vi: "Tuyển chọn, phỏng vấn và quản lý ứng viên Bangladesh một cách minh bạch, an toàn và tối ưu chi phí cho nhà máy của bạn.",
          bn: "হ্যালোজব আপনাকে বাংলাদেশের সবচেয়ে নির্ভরযোগ্য জনশক্তি রপ্তানিকারক এজেন্সিগুলোর সাথে দ্রুত এবং বিশ্বস্ততার সাথে সংযুক্ত করে আপনার স্বপ্নের ক্যারিয়ার গড়তে সাহায্য করে।"
        }
      }
    },
    backHome: { vi: "Quay lại trang chủ", bn: "হোমপেজে ফিরে যান" },
    invalidRef: {
      title: { vi: "Mã giới thiệu không hợp lệ", bn: "রেফারেল কোড অবৈধ" },
      desc: { vi: "Mã giới thiệu của Đại lý không tồn tại hoặc chưa được phê duyệt. Vui lòng liên hệ với Đại lý để xác nhận lại.", bn: "এজেন্সির রেফারেল কোডটি নেই বা অনুমোদিত নয়। অনুগ্রহ করে নিশ্চিত করতে আপনার এজেন্সির সাথে যোগাযোগ করুন।" },
      button: { vi: "Đồng ý", bn: "ঠিক আছে" },
      loading: { vi: "Đang xác thực mã giới thiệu...", bn: "রেফারেল কোড যাচাই করা হচ্ছে..." }
    }
  },
  metadata: {
    shareDocuments: {
      title: { vi: "Tài liệu chia sẻ - HelloJob", bn: "শেয়ার করা নথি - হ্যালোজব" },
      desc: { vi: "Kho dữ liệu và tài liệu chia sẻ dành riêng cho đối tác.", bn: "অংশীদারদের জন্য ব্যক্তিগত ডেটা স্টোর এবং শেয়ার করা নথি।" }
    },
    candidates: {
      title: { vi: "Tìm kiếm ứng viên - Agency", bn: "প্রার্থী অনুসন্ধান - এজেন্সি" },
      desc: { vi: "Tìm kiếm và lọc hồ sơ ứng viên cho Đối tác", bn: "এজেন্সির জন্য প্রার্থীদের অনুসন্ধান এবং ফিল্টার করুন" }
    },
    updateCandidate: {
      title: { vi: "Sơ yếu lý lịch | HelloJob", bn: "জীবনবৃত্তান্ত | হ্যালোজব" },
      desc: { vi: "Hoàn thiện các thông tin chi tiết để gửi đến nhà tuyển dụng.", bn: "নিয়োগকর্তার কাছে পাঠানোর জন্য বিস্তারিত তথ্য সম্পূর্ণ করুন" }
    },
    roadmap: {
      title: { vi: "Quy trình phát triển thị trường", bn: "সহযোগিতার পথচিত্র - এজেন্সি" },
      desc: { vi: "Quy trình trở thành đối tác cung ứng nhân lực chính thức của HelloJob.", bn: "হ্যালোজব-এর অফিসিয়াল জনশক্তি সরবরাহ অংশীদার হওয়ার প্রক্রিয়া।" }
    },
    home: {
      title: { vi: "Mô hình Đại lý cung ứng nhân lực Bangladesh tại Việt Nam", bn: "হ্যালোজব - ভিয়েতনামী জনশক্তি সংস্থাগুলোর জন্য বাংলাদেশি জনশক্তি সরবরাহ সমাধান" },
      desc: { vi: "Hệ thống kết nối và cung ứng nhân lực Bangladesh chất lượng cao cho các đại lý và doanh nghiệp tại Việt Nam.", bn: "ভিয়েতনামী সংস্থা এবং ব্যবসার জন্য উচ্চমানের বাংলাদেশী জনশক্তি সরবরাহ ও সংযোগ ব্যবস্থা।" }
    }
  },
  errors: {
    candidateNotFound: { vi: "Mã ứng viên không tồn tại", bn: "প্রার্থীর আইডি বিদ্যমান নেই" },
    accessError: { vi: "Lỗi truy cập dữ liệu cho ứng viên", bn: "প্রার্থীর জন্য ডেটা অ্যাক্সেস ত্রুটি" },
    backToHub: { vi: "Quay lại Hub", bn: "ড্যাশবোর্ডে ফিরে যান" },
    accessDenied: {
      title: { vi: "Truy cập bị từ chối", bn: "প্রবেশাধিকার অস্বীকার করা হয়েছে" },
      desc: { vi: "Bạn không có quyền truy cập vào khu vực dành riêng cho Đối tác.", bn: "আপনার পার্টনারদের জন্য সংরক্ষিত এলাকায় প্রবেশের অনুমতি নেই।" },
      button: { vi: "Về trang chủ", bn: "হোমপেজে ফিরে যান" }
    }
  },
  alt: {
    solution: { vi: "Giải pháp HelloJob", bn: "হ্যালোজব সমাধান" },
    partners: { vi: "Đối tác nhân lực Bangladesh", bn: "বাংলাদেশি জনশক্তি অংশীদার" },
    cooperation: { vi: "Hợp tác Bangladesh - Việt Nam", bn: "বাংলাদেশ-ভিয়েতনাম সহযোগিতা" }
  },
  common: {
    filteringBy: { vi: "Đang lọc theo", bn: "ফিল্টার করা হচ্ছে" },
    all: { vi: "Tất cả", bn: "সব" }
  },
  hover: {
    level1: { vi: "Đại lý cấp 1", bn: "স্তর ১ এজেন্সি" },
    industry: { vi: "Ngành nghề", bn: "শিল্প" },
    representative: { vi: "Người đại diện", bn: "প্রতিনিধি" },
    company: { vi: "Công ty", bn: "কোম্পানি" },
    address: { vi: "Địa chỉ", bn: "ঠিকানা" },
    phone: { vi: "Điện thoại", bn: "ফোন" },
    rlNumber: { vi: "Mã số RL", bn: "আরএল নম্বর" },
    established: { vi: "Thành lập", bn: "প্রতিষ্ঠিত" },
    website: { vi: "Website", bn: "ওয়েবসাইট" },
    email: { vi: "Email", bn: "ইমেইল" },
    verified: { vi: "Đã xác thực", bn: "যাচাইকৃত" },
    master: { vi: "Tổng đại lý", bn: "মাস্টার এজেন্ট" },
  }
};
